/**
 * @todo optimize performance
 */
export default function checkQuestionInTags(question = '', tags = []) {
  let inTags = false;

  tags
    .map(str =>
      str
        .toLowerCase()
        .split(',')
        .map(word => word.trim())
    )
    .forEach(list => {
      if (!inTags) {
        inTags = list.every(
          substring =>
            question
              .toLowerCase()
              .trim()
              .indexOf(substring) >= 0
        );
      }
    });

  return inTags;
}
